import {Injectable} from '@angular/core';
import {MessageService as PrimeMessageService} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  constructor(private primeMessage: PrimeMessageService) {}

  showError(msg: string) {
    this.primeMessage.add({
      severity: 'error',
      summary: 'Error',
      detail: msg,
      life: 4000
    });
  }

  showErrorHtml(msg: string) {
    this.primeMessage.add({
      key: 'massive-load',
      severity: 'error',
      summary: 'Error',
      detail: msg,
      life: 8000
    });
  }

  showMassiveLoadSuccess(msg: string) {
    this.primeMessage.add({
      key: 'massive-load',
      severity: 'success',
      summary: 'Success',
      detail: msg,
      life: 4000
    });
  }

  showSuccess(msg: string) {
    this.primeMessage.add({
      severity: 'success',
      summary: 'Success',
      detail: msg,
      life: 4000
    });
  }
}
